import { Button, Container } from 'react-bootstrap';
import ReactGA from 'react-ga';
import styled from 'styled-components';

import { Caption } from 'components/ui/Caption';
import { DiamondSeparator } from 'components/ui/Separators';

const VisitUsContainer = styled.section`
    padding-top: 120px;
    padding-bottom: 120px;

    width: 100%;

    background-color: var(--background-white);
`;

const MapButton = styled(Button)`
    width: 180px;
    height: 60px;

    font-size: 16px !important;
    padding: 16px !important;
`;

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    & > * {
        margin: 10px;
    }

    @media (max-width: ${(props): string => props.theme.sm}px) {
        flex-direction: column;
    }
`;

function VisitUsSection(): JSX.Element {
    const handleGoTo = (store: string): void => {
        ReactGA.event({
            category: 'Usuario',
            action: `Ubicar punto de venta: ${store}`,
        });
    };

    return (
        <VisitUsContainer id="visit">
            <Container>
                <Caption>
                    <h2>
                        Puntos de <strong>Venta</strong>
                    </h2>
                    <DiamondSeparator />
                </Caption>
                <ButtonsContainer>
                    <MapButton
                        href="https://goo.gl/maps/G7hcuYyUGgcUeBck8"
                        onClick={(): void => handleGoTo('Arequipa')}
                    >
                        Arequipa
                    </MapButton>
                    <MapButton
                        href="https://goo.gl/maps/r93JTH3RcUz7C7Ez9"
                        onClick={(): void => handleGoTo('Puno')}
                    >
                        Puno
                    </MapButton>
                    <MapButton
                        href="https://goo.gl/maps/eqTRYFCLfcr9Updp7"
                        onClick={(): void => handleGoTo('Juliaca')}
                    >
                        Juliaca
                    </MapButton>
                </ButtonsContainer>
            </Container>
        </VisitUsContainer>
    );
}

export default VisitUsSection;
